export default __webpack_public_path__ + "static/media/photo04_pc@2x.8203e9ef.jpg";